<template>
  <div id="main" class="index">
    <topNav></topNav>
    <div class="lawcDetail">
      <div class="backconout">
        <div
          class="backcon"
          @mouseenter="mosein"
          @mouseout="mouseout"
          @click="backfun"
        >
          <img class="backconImg" :src="imgsrc" alt="" />
          <span class="backconSpan">返回相关声明列表</span>
        </div>
      </div>
      <div class="inline-html">
        <section class="text">
          <div id="_jss" v-if="showH.fxjss" class="hbox fxjss">
            <p class="textTitel">
              <span id="declarationTitel">风险揭示书</span>
            </p>
            <div class="textMain">
              <p class="bold">
                依据《证券投资顾问业务暂行规定》，开展证券投资顾问业务的证券公司、证券投资咨询机构应向投资者提供<span
                  class="textRed"
                  >《证券投资顾问业务风险揭示书》</span
                >，充分揭示接受证券投资顾问服务中存在的风险。
              </p>
              <p class="lip">
                <span class="tred">一、</span
                >提示投资者在接受证券投资顾问服务前，必须了解提供服务的证券公司、证券投资咨询机构是否具备证券投资咨询业务资格，证券公司、证券投资咨询
                机构提供服务的人员是否具备证券投资咨询执业资格并已经注册登记为证券投资顾问。
              </p>
              <p class="lip">
                <span class="tred">二、</span
                >提示投资者在接受证券投资顾问服务前，必须了解证券投资顾问业务的含义，理解投资者接受证券投资顾问服务后需自主作出投资决策并独立承担投资风险。
              </p>
              <p class="lip">
                <span class="tred">三、</span
                >提示投资者在接受证券投资顾问服务前，必须了解证券公司、证券投资咨询机构及其人员提供的证券投资顾问服务不能确保投资者获得盈利或本金不受损失。
              </p>
              <p class="lip">
                <span class="tred">四、</span
                >提示投资者在接受证券投资顾问服务前，必须了解证券公司、证券投资咨询机构及其人员提供的投资建议具有针对性和时效性，不能在任何市场环境下长期有效。
              </p>
              <p class="lip">
                <span class="tred">五、</span
                >提示投资者在接受证券投资顾问服务前，必须了解作为投资建议依据的证券研究报告和投资分析意见等，可能存在不准确、不全面或者被误读的风险，投资者可以向证券投资顾问了解证券研究报告的发布人和发布时间以及投资分析意见的来源，以便在进行投资决策时作出理性判断。
              </p>
              <p class="lip">
                <span class="tred">六、</span
                >提示投资者在接受证券投资顾问服务前，必须了解所在的证券公司、证券投资咨询机构证券投资顾问服务的收费标准和方式，按照公平、合理、自愿的原则与证券公司、证券投资咨询机构协商并书面约定收取证券投资顾问服务费用的安排。证券投资顾问服务收费应向公司账户支付，不得向证券投资顾问人员或其他个人账户支付。
              </p>
              <p class="lip">
                <span class="tred">七、</span
                >提示投资者在接受证券投资顾问服务前，必须了解证券公司、证券投资咨询机构及其人员可能存在道德风险，如投资者发现投资顾问存在违法违规行为或利益冲突情形，如泄露客户投资决策计划、传播虚假信息、进行关联交易等，投资者可以向证券公司、证券投资咨询机构投诉或向有关部门举报。
              </p>
              <p class="lip">
                <span class="tred">八、</span
                >提示投资者在接受证券投资顾问服务前，必须了解证券公司、证券投资咨询机构存在因停业、解散、撤销、破产，或者被中国证监会撤销相关业务许可、责令停业整顿等原因导致不能履行职责的风险。
              </p>
              <p class="lip">
                <span class="tred">九、</span
                >、提示投资者在接受证券投资顾问服务前，必须了解证券公司、证券投资咨询机构的投资顾问人员存在因离职、离岗等原因导致更换投资顾问服务人员并影响服务连续性的风险。
              </p>
              <p class="lip">
                <span class="tred">十、</span
                >提示投资者在接受证券投资顾问服务前，应向证券公司、证券投资咨询机构说明自身资产与收入状况、投资经验、投资需求和风险偏好等情况并接受评估，以便于证券公司、证券投资咨询机构根据投资者的风险承受能力和服务需求，向投资者提供适当的证券投资顾问服务。
              </p>
              <p class="lip">
                <span class="tred">十一、</span
                >提示投资者在接受证券投资顾问服务前，应向证券公司、证券投资咨询机构提供有效的联系方式和服务获取方式，如有变动须及时向所在的证券公司、证券投资咨询机构进行说明，如因投资者自身原因或不可抗力因素导致投资者未能及时获取证券投资顾问服务，责任将由投资者自行承担。
              </p>
              <p class="lip">
                <span class="tred">十二、</span
                >提示投资者在接受证券投资顾问服务时，应保管好自己的证券账户、资金账户和相应的密码，不要委托证券投资顾问人员管理自己的证券账户、资金账户，代理买卖证券，否则由此导致的风险将由投资者自行承担。
              </p>
              <p class="lip">
                <span class="tred">十三、</span
                >证券公司、证券投资咨询机构以软件工具、终端设备等为载体，向客户提供投资建议或者类似功能服务的，应提示投资者在接受该软件工具、终端设备等前，必须仔细阅读相关说明书，了解其实际功能、信息来源、固有缺陷和使用风险，由于投资者自身原因导致该软件工具、终端设备等使用不当或受到病毒入侵、黑客攻击等不良影响的，由此导致的风险将由投资者自行承担。如表示该软件工具、终端设备具有选择证券投资品种或者提示买卖时机功能的，应提示投资者了解其方法和局限。
              </p>
              <p class="bold">
                本风险揭示书的揭示事项仅为列举性质，未能详尽列明投资者接受证券投资顾问服务所面临的全部风险和可能导致投资者投资损失的所有因素。
                投资者在接受证券投资顾问服务前，应认真阅读并理解相关业务规则、证券投资顾问服务协议及本风险揭示书的全部内容。
                接受证券投资顾问服务的投资者，自行承担投资风险，证券公司、证券投资咨询机构不以任何方式向投资者作出不受损失或者取得最低收益的承诺。
                特别提示：投资者应签署本风险揭示书，表明投资者已经理解并愿意自行承担接受证券投资顾问服务的风险和损失。
              </p>
            </div>
          </div>
          <div id="_mz" v-if="showH.mzsm" class="hbox mzsm">
            <p class="textTitel">
              <span>免责声明</span>
            </p>
            <div class="textMain">
              <p class="lip">
                <span class="tred">一、</span
                >本公司系中国证监会核准的证券投资咨询专业机构，依法开展证券投资咨询业务。如有发现任何机构或个人冒用本公司或本公司分析师名义在网络上非法从事投资咨询业务，请及时与本公司联系并向监管部门举报，本公司保留对侵权机构或个人追究法律责任的权利。
              </p>
              <p class="lip">
                <span class="tred">二、</span
                >本网站的内容受中国知识产权法相关法律法规及相关国际条约的保护。除法律另有规定或本公司与第三方另有约定外，本网站提供的所有资料以及相关软件程序的知识产权均归属本公司所有。
              </p>
              <p class="lip">
                <span class="tred">三、</span
                >任何机构或者个人使用本网站，均应遵守中国有关法律与本声明，不得破坏本网站运行安全，不得利用本网站进行任何违法活动，不得损害本公司的合法权益。
              </p>
              <p class="lip">
                <span class="tred">四、</span
                >未经本公司书面许可，任何机构或个人不得以向他人出售牟利为目的使用本网站的任何内容，此种使用包括但不限于拷贝、下载、存贮、通过硬盘拷贝或电子抓取系统获取、发送、转换、出租、演示、转载、复制、修改、销售、传播、出版或任何其它形式的散发。
              </p>
              <p class="lip">
                <span class="tred">五、</span
                >本网站对所提供的内容力求准确、完整和及时，但并不对其准确性、完整性和及时性做出任何保证。对任何因直接或间接使用本网站内容而造成的损失，包括但不限于因有关内容不准确、不完整而导致的损失，本公司不承担任何法律责任。本网站亦不保证所设置的外部链接的准确性和完整性。任何机构或者个人通过本网站与其他网站的链接而获得其他网站内容，其风险责任自负，本公司对此不承担任何法律责任。
              </p>
              <p class="lip">
                <span class="tred">六、</span
                >权利人认为本网站所提供的信息存储空间、搜索或链接服务存储、搜索或链接的内容所涉及的作品侵犯了其信息网络传播权或者被删除、改变了自己的权利管理电子信息的，可依法向本网站提交书面通知。权利人应对通知书的真实性负责，并承担由于通知书内容不真实所导致的全部法律责任。
              </p>
              <p class="lip">
                <span class="tred">七、</span
                >本声明在网站相关页面发布。本网站郑重提示：任何机构或者个人进入本网站，即被视为已完全知悉、理解并接受本声明的全部内容。本公司保留对本声明的修改、解释权
              </p>
            </div>
          </div>
          <div id="_gs" v-if="showH.gssm" class="hbox gssm">
            <p class="textTitel">
              <span>公司声明</span>
            </p>
            <div class="textMain">
              <ul>
                <li>
                  <p class="lititle">第一条</p>
                  <p class="notex">
                    本公司承诺提供专业服务，但不向投资者承诺保底或者保证收益，也不与投资者约定分享投资收益或分担投资损失。市场有风险，投资需谨慎。
                  </p>
                </li>
                <li>
                  <p class="lititle">第二条</p>
                  <p class="notex">
                    本网站所刊载的所有资料及图表仅供参考使用。刊载这些文档并不构成对任何股份的收购、购买、认购、抛售或持有的邀约或意图。参阅本网站上所刊的文档的用户，应被视为已确认得悉上述立场。投资者依据本网站提供的信息、资料及图表进行金融、证券等投资项目所造成的盈亏与本网站无关。
                  </p>
                </li>
                <li>
                  <p class="lititle">第三条</p>
                  <p class="notex">
                    本网站如因系统维护或升级而需暂停服务，或因线路及非本公司控制范围外的硬件故障或其它不可抗力而导致
                  </p>
                </li>
                <li>
                  <p class="lititle">第四条</p>
                  <p class="notex">
                    凡以任何方式登陆本网站或直接、间接使用本网站资料者，视为自愿接受本网站声明的约束。
                  </p>
                </li>
                <li>
                  <p class="lititle">第五条</p>
                  <p class="notex">
                    本声明未涉及的问题参见国家有关法律法规，当本声明与国家法律法规冲突时，以国家法律法规为准。
                  </p>
                </li>
                <li>
                  <p class="lititle">第六条</p>
                  <p class="notex">
                    本网站之声明以及其修改权、更新权及最终解释权均属财富在线（深圳）科技有限公司所有。
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div id="_ysbh" v-if="showH.dcjys" class="hbox ysbh">
            <p class="textTitel">
              <span>德财院隐私保护政策</span>
            </p>
            <div class="textMain">
              <ul>
                <li>
                    <p class="textTitle" style="text-align: right;">本版本发布日期：2024年5月20日</p>
                    <p class="textTitle" style="text-align: right;">生效日期：2024年5月20日</p>
                </li>
                <li>
                  <p class="text2 shsj">
                    尊敬的德财院用户：我们对《德财院隐私保护政策》进行了更新，此版本更新主要集中在文案汇总、归纳及优化，以便于您更加清晰、直观了解个人信息的保护政策。
                  </p>
                </li>
                <li>
                  <p class="textTitle shsj">【特别提示】</p>
                  <p class="textTitle shsj">
                        本政策仅适用于财富在线（深圳）科技有限公司及其关联公司提供的产品和服务及其延伸的功能（以下简称“德财院服务”），包括德财院网站、德财院H5页面及德财院APP、客户端、小程序以及随技术发展出现的新形态向您提供的各项产品和服务。如我们提供的某款产品有单独的隐私政策或相应的用户服务协议当中存在特殊约定，则该产品的隐私政策将优先适用，该款产品隐私政策和用户服务协议未涵盖的内容，以本政策内容为准。如我们关联公司的产品或服务中使用了德财院提供的产品或服务但未设置独立隐私政策的，则本隐私政策同样适用于该部分产品或服务。
                  </p>
                  <p class="textTitle shsj">请仔细阅读《德财院隐私保护政策》（尤其是粗体内容）并确定了解我们对您个人信息的处理规则。阅读过程中，如您有任何疑问，可通过《德财院隐私政策》中的联系方式咨询我们。</p>
                  <p class="text2 shsj">版本更新日期：2024年5月20日</p>
                  <p class="text2 shsj">版本生效日期：2024年5月20日</p>      
                  <p class="text2 shsj">如您有任何疑问、意见或建议，您可通过以下联系方式与我们联系：</p>
                  <p class="text2 shsj">联系电话：0755-25885666</p>
                  <p class="text2 shsj">注册地址：深圳市罗湖区笋岗街道洪湖社区洪湖二街50号新南滨大楼3层-4层</p>
                  <p class="text2 shsj">常用办公地址：深圳市罗湖区笋岗街道洪湖社区洪湖二街50号新南滨大楼3层-4层</p>
                  <p class="textTitle shsj">引言</p>
                  <p class="text2 shsj">欢迎您使用德财院！我们非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《德财院隐私保护政策》（“本隐私政策”）向您说明在您使用我们的产品与/或服务时我们如何收集、使用、保存、共享和转移这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。</p>
                  <p class="text2 shsj">本隐私政策将帮助您了解以下内容：</p>
                  <p class="textTitle shsj">一、我们如何收集和使用您的个人信息</p>
                  <p class="textTitle shsj">二、我们如何使用Cookies和同类技术</p>
                  <p class="textTitle shsj">三、我们如何对外提供您的个人信息</p>
                  <p class="textTitle shsj">四、我们如何保护和保存您的个人信息</p>
                  <p class="textTitle shsj">五、您如何管理个人信息</p>
                  <p class="textTitle shsj">六、未成年人的个人信息保护</p>
                  <p class="textTitle shsj">七、通知和修订</p>
                  <p class="textTitle shsj">八、如何联系我们</p>
                  <p class="textTitle shsj">本隐私政策与您所使用的德财院服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本隐私政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。</p>
                  <p class="textTitle shsj">一、我们如何收集个人信息</p>
                  <p class="textTitle shsj">个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。</p>
                  <p class="textTitle shsj">我们会遵循正当、合法、必要的原则，出于本政策所述的以下目的，收集和使用您在使用产品与/或服务过程中主动提供或因使用产品与/或服务而产生的个人信息，以及从第三方获取您的相关个人信息。如果我们要将您的个人信息用于本政策未载明的其他用途，或将基于特定目的收集而来的信息用于其他目的，我们将以合理的方式向您告知，并在使用前再次征得您的同意。</p>
                  <p class="textTitle shsj">（一）您须授权我们收集和使用您个人信息的情形</p>
                  <p class="textTitle shsj">我们的产品与/或服务包括一些核心功能，这些功能包含了实现德财院产品/服务所必须的功能及保障交易安全所必须的功能。我们可能会收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的产品与/或服务。这些功能包括：</p>
                  <p class="textTitle shsj">1、实现德财院产品/服务所必须的功能</p>
                  <p class="textTitle shsj">（1）账号注册、登录与验证</p>
                  <p class="text2 shsj">当您注册德财院账号时，您至少需要向我们提供您准备使用的<span class="textTitle">德财院账号名、密码、手机号码、电子邮箱，</span>我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效，通过SIM卡信息识别并显示对应的运营商。您的账号名为您的默认昵称，您可以修改和补充<span class="textTitle">您的昵称、性别、生日以及您的实名认证相关信息，</span>这些信息均属于您的“账号信息”。您补充的账号信息将有助于我们为您提供的商品、和更优的购物体验，但如果您不提供这些补充信息，不会影响您使用德财院的基本功能。</p>
                  <p class="text2 shsj">当您成功注册德财院账号后，可以使用德财院账号登录“德财院商城”，登录时您需要向我们提供您的德财院账号信息。若您不提供这类信息，您将无法登录和在“德财院商城”购买商品，此时您可使用浏览和搜索功能，我们将不会收集您的上述个人信息。</p>
 
                  <p class="textTitle shsj">（2）商品/服务信息展示和搜索</p>
                  <p class="text2 shsj">为了向您展示商品或者服务，我们会收集您的<span class="textTitle">设备信息（包括设备名称、设备型号、MAC地址及IMEI、设备识别码、移动应用列表等软硬件特征信息、操作系统和应用程序版本、语言设置、分辨率、服务提供商网络ID（PLMN））、设备所在位置相关信息（包括您授权的GPS位置信息以及WLAN接入点、蓝牙和基站传感器信息）、浏览器类型</span>来对相应的商品或者服务内容进行排序以适应您的设备界面。</p>
                  <p class="text2 shsj">为了向您提供搜索历史、浏览记录、收藏的商品或关注的老师、购物车或订单商品或服务展示服务，我们会收集您的<span class="textTitle">浏览信息、搜索记录、收藏记录、关注记录、加购信息、订单信息。</span></p>
                  <p class="textTitle shsj">（3）下单及订单管理</p>
                  <p class="text2 shsj">当您准备对您购买的商品进行结算时，德财院系统会生成您购买商品的订单。该订单中<span class="textTitle">会载明订单号、您所购买的商品或服务信息、下单时间、您应支付的货款金额及支付方式</span>。</p>
                  <p class="text2 shsj">上述所有信息构成您的<span class="textTitle">“订单信息”</span>，我们将使用您的订单信息来（包括与为您提供上述服务的第三方）进行您的身份核验、确定交易、支付结算、为您查询订单以及提供客服咨询与售后服务。我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。</p>
                  <p class="textTitle shsj">（4）支付功能</p>
                  <p class="text2 shsj">在您下单后，您可以选择德财院的关联方或与德财院合作的第三方支付机构（包括德财院支付、微信支付，以下称“支付机构”）所提供的支付服务。支付功能本身并不收集您的个人信息，<span class="textTitle">但我们需要将您的德财院订单号与交易金额信息，包括您的银行卡号、有效期及其他银行卡（含储蓄卡、信用卡）支付必要信息与这些支付机构共享以实现其确认您的支付指令并完成支付，以及您开通、使用德财院钱包的账户金额信息，以便您能正常使用钱包功能。</span></p>
                  <p class="textTitle shsj">（5）交付产品与/或服务功能</p>
                  <p class="text2 shsj">在当您下单并在线完成支付后，德财院、德财院的关联方、供应商、与德财院合作的商家或第三方将为您完成订单的交付。您知晓并同意，<span class="textTitle">德财院、德财院的关联方、供应商、与德财院合作的商家</span>会在上述环节内使用您的订单信息以保证您的订购的商品/服务能够正常使用。</p>
                  <p class="text2 shsj">如德财院商品/<span class="textTitle">服务基于某些业务法律要求实名认证的需求，要求您进行实名认证</span>，我们会会协助您完成实名认证。我们在此环节会使用您的身份证通过国家有权认证机构的专有设备对您的身份进行核验，我们不会收集您的身份证信息，且我们的服务人员均须遵守公司保密制度的规定。</p>
                  <p class="textTitle shsj">（6）客服与售后功能</p>
                  <p class="text2 shsj">我们的电话客服和售后功能会使用您的账号信息和订单信息。为保证您的账号安全，我们的呼叫客服和在线客服会使用您的账号信息与您<span class="textTitle">核验您</span>的身份。当您需要我们提供与您订单信息相关的客服与售后服务时，我们将会查询您的订单信息。您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息，如当您要求我们变更联系人或联系电话。</p>
                  <p class="textTitle shsj">2、保障交易安全所必须的功能</p>
                  <p class="text2 shsj">为保障您使用我们的产品与/或服务时系统的稳定性和安全性，防止您的个人信息被非法获取，更准确地预防欺诈和保护账号安全，我们需要收集您的<span class="textTitle">设备信息（设备型号、设备Mac地址、ANDROID_ID、应用进程列表、设备识别码、设备序列号、操作系统及软件版本、设备状态、网络状况）、历史上网记录、日志信息、面部信息、IP地址、位置信息、浏览信息、订单信息、常用软件列表、ssid、wifi信息、IMSI、SIM卡信息、电池使用情况来识别是否为真实自然人用户、是否为异常地点登录、判断您的账号风险，</span>并可能会记录一些我们认为有风险的链接（“URL”）；我们也会收集您的设备信息用于对德财院系统问题进行分析、统计流量并排查可能存在的风险，在您选择向我们发送异常信息时予以排查。如果您不提供上述信息，我们则无法在您使用德财院服务过程中对您的服务及账号安全进行保护。</p>
                  <p class="textTitle shsj">（二）您可自主选择提供的个人信息的情形</p>
                  <p class="text2 shsj">为使您适用德财院产品/服务更便捷或更有乐趣，从而提升您在德财院的学习体验，我们在扩展功能中可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以适用德财院产品/服务，但您可能无法使用为您带来乐趣的扩展功能或在购买某些产品/服务时需要重复填写一些信息。关于这些扩展功能收集的信息和使用目的，详见以下内容：</p>
                  <p class="textTitle shsj">ANDROID设备权限;</p>
                  <p class="text2 shsj">权限类型：摄像头（相机）</p>
                  <p class="text2 shsj">权限名称：android.permission.CAMERA</p>
                  <p class="text2 shsj">权限功能说明：使用拍摄视频、照片、扫码</p>
                  <p class="text2 shsj">使用场景或目的：完成视频拍摄、拍照、扫码以及人脸识别登录</p>
                  <p class="text2 shsj">权限名称：android.permission.WRITE_EXTERNAL_STORAGE(读取存储)；</p>
                  <p class="text2 shsj">android.permission.READ_EXTERNAL_STORAGE（写入存储）；</p>
                  <p class="text2 shsj">权限功能说明：上传照片/视频</p>
                  <p class="text2 shsj">使用场景或目的：拍照购买产品/服务功能和晒单、评价及问答功能</p>
                  <p class="text2 shsj">权限类型：麦克风</p>
                  <p class="text2 shsj">权限名称：android.permission.RECORD_AUDIO；</p>
                  <p class="text2 shsj">使用场景或目的：社交互动，识别您的购物需求以及客服与售后需求</p>
                  <p class="text2 shsj">权限名称：android.permission.READ_CONTACTS</p>
                  <p class="text2 shsj">权限功能说明：获取通讯录信息</p>
                  <p class="text2 shsj">使用场景或目的：手机充值、社交互动</p>
                  <p class="text2 shsj">权限类型：日历</p>
                  <p class="text2 shsj">权限名称：android.permission.READ_CALENDAR(读日历)；</p>
                  <p class="text2 shsj">android.permission.WRITE_CALENDAR（写入日历）</p>
                  <p class="text2 shsj">权限功能说明：编辑、添加您关注的直播、活动等日程</p>
                  <p class="text2 shsj">使用场景或目的：用于识别日历中添加关注直播、活动的日程并提醒</p>
                  <p class="text2 shsj">权限类型：电话</p>
                  <p class="text2 shsj">权限名称：android.permission.READ_PHONE_STATE</p>
                  <p class="text2 shsj">权限功能说明：识别您的本机识别码</p>
                  <p class="text2 shsj">使用场景或目的：完成安全风控、进行统计和服务推送</p>
                  <p class="text2 shsj">权限类型：外置存储器</p>
                  <p class="text2 shsj">权限名称：android.permission.WRITE_EXTERNAL_STORAGE(读取存储)；</p>
                  <p class="text2 shsj">android.permission.READ_EXTERNAL_STORAGE（写入存储）</p>
                  <p class="text2 shsj">权限功能说明：读取或向其中写入图片、文件、崩溃日志信息等必要信息</p>
                  <p class="text2 shsj">使用场景或目的：允许读取或者写入图片、文件等内容，用于提供信息发布</p>
                  <p class="text2 shsj">或在本地记录崩溃日志信息等功能，保障客户端的稳定运行</p>
                  <p class="text2 shsj">权限类型：面容ID/触控ID</p>
                  <p class="text2 shsj">权限名称：android.permission.CAMERA（面容ID）；</p>
                  <p class="text2 shsj">android.permission.USE_FINGERPRINT（指纹ID）</p>
                  <p class="text2 shsj">权限功能说明：访问面容信息或指纹信息</p>
                  <p class="text2 shsj">使用场景或目的：提供基于面容ID/触控ID进行身份验证功能</p>
                  <p class="text2 shsj">权限类型：NFC（Android）</p>
                  <p class="text2 shsj">权限名称：android.permission.NFC</p>
                  <p class="text2 shsj">权限功能说明：选择闪付卡支付</p>
                  <p class="text2 shsj">使用场景或目的：支付</p>
                  <p class="text2 shsj">权限类型：剪切板</p>
                  <p class="text2 shsj">权限功能说明：访问剪切板内容</p>
                  <p class="text2 shsj">使用场景或目的：复制、分享信息、标题、短信验证码</p>
                  <p class="text2 shsj">权限名称：android.permission.INTERNET</p>
                  <p class="text2 shsj">权限功能说明：访问网络权限</p>
                  <p class="text2 shsj">使用场景或目的：实现应用程序联网</p>
                  <p class="text2 shsj">权限名称：android.permission.ACCESS_WIFI_STATE</p>
                  <p class="text2 shsj">权限功能说明：获取WiFi状态权限</p>
                  <p class="text2 shsj">使用场景或目的：监控网络变化，提示用户当前网络环境</p>
                  <p class="text2 shsj">权限名称：android.permission.ACCESS_NETWORK_STATE</p>
                  <p class="text2 shsj">权限功能说明：获取网络状态权限</p>
                  <p class="text2 shsj">使用场景或目的：监控网络变化，提示用户当前网络环境</p>
                  <p class="text2 shsj">权限名称：android.permission.VIBRATE</p>
                  <p class="text2 shsj">权限功能说明：使用振动权限</p>
                  <p class="text2 shsj">使用场景或目的：允许手机振动</p>
                  <p class="text2 shsj">权限名称：android.permission.WAKE_LOCK</p>
                  <p class="text2 shsj">权限功能说明：唤醒锁定权限</p>
                  <p class="text2 shsj">使用场景或目的：允许程序在手机屏幕关闭后后台进程仍然运行，保持屏幕唤醒</p>
                  <p class="text2 shsj">权限名称：android.permission.RESTART_PACKAGES</p>
                  <p class="text2 shsj">权限功能说明：结束系统任务权限</p>
                  <p class="text2 shsj">使用场景或目的：重新启动应用</p>
                  <p class="text2 shsj">权限名称：android.permission.MODIFY_AUDIO_SETTINGS</p>
                  <p class="text2 shsj">权限功能说明：修改声音设置权限</p>
                  <p class="text2 shsj">使用场景或目的：修改全局音频设置，例如调节音量和用于输出的扬声器</p>
                  <p class="text2 shsj">权限名称：android.permission.BLUETOOTH_ADMIN</p>
                  <p class="text2 shsj">权限功能说明：蓝牙管理权限</p>
                  <p class="text2 shsj">使用场景或目的：蓝牙功能模块使用</p>
                  <p class="text2 shsj">权限名称：android.permission.SYSTEM_ALERT_WINDOW</p>
                  <p class="text2 shsj">权限功能说明：悬浮窗权限</p>
                  <p class="text2 shsj">使用场景或目的：观看直播、短视频悬浮窗播放</p>
                  <p class="text2 shsj">权限名称：android.permission.ACCESS_BACKGROUND_LOCATION</p>
                  <p class="text2 shsj">权限功能说明：支持后台访问位置权限</p>
                  <p class="text2 shsj">使用场景或目的：保持持续定位能力</p>
                  <p class="text2 shsj">权限名称：android.permission.WRITE_SYSTEM</p>
                  <p class="text2 shsj">权限功能说明：读写系统设置权限</p>
                  <p class="text2 shsj">使用场景或目的：允许应用读写系统设置项</p>
                  <p class="text2 shsj">权限名称：android.permission.GET_TASKS</p>
                  <p class="text2 shsj">权限功能说明：获取任务信息权限</p>
                  <p class="text2 shsj">使用场景或目的：允许应用获取当前或最近运行的应用</p>
                  <p class="text2 shsj">权限名称：android.permission.CHANGE_WIFI_STATE</p>
                  <p class="text2 shsj">权限功能说明：改变WiFi状态权限</p>
                  <p class="text2 shsj">使用场景或目的：允许应用改变WiFi状态</p>
                  <p class="text2 shsj">权限名称：android.permission.CHANGE_NETWORK_STATE</p>
                  <p class="text2 shsj">权限功能说明：改变网络连接状态</p>
                  <p class="text2 shsj">使用场景或目的：允许应用改变网络连接状态</p>
                  <p class="text2 shsj">权限名称：android.permission.ACCESS_LOCATION_EXTRA_COMMANDS</p>
                  <p class="text2 shsj">权限功能说明：允许程序访问额外的定位提供者指令获取模拟定位信息</p>
                  <p class="text2 shsj">使用场景或目的：刷脸支付功能</p>
                  <p class="text2 shsj">权限名称：android.permission.WRITE_SETTINGS</p>
                  <p class="text2 shsj">权限功能说明：允许写设备缓存/允许程序读取或写入系统设置</p>
                  <p class="text2 shsj">使用场景或目的：移动一键登录</p>
                  <p class="textTitle shsj">iOS操作系统应用权限列表</p>
                  <p class="text2 shsj">权限类型：摄像头（相机）</p>
                  <p class="text2 shsj">权限名称：NSCameraUsageDescription</p>
                  <p class="text2 shsj">权限功能说明：扫码、拍摄、AR互动或实景购物</p>
                  <p class="text2 shsj">使用场景或目的：完成视频拍摄、拍照、扫码以及人脸识别登录</p>
                  <p class="text2 shsj">权限类型：相册</p>
                  <p class="text2 shsj">权限名称：NSPhotoLibraryAddUsageDescription(相册添加)；</p>
                  <p class="text2 shsj">NSPhotoLibraryUsageDescription(相册使用)</p>
                  <p class="text2 shsj">权限功能说明：使用拍照购搜索产品/服务，在评论、分享、售后、反馈意见时上传或保存图片和视频</p>
                  <p class="text2 shsj">使用场景或目的：社交使用，拍照晒单、评价及问答功能</p>
                  <p class="text2 shsj">权限类型：麦克风</p>
                  <p class="text2 shsj">权限名称：NSMicrophoneUsageDescription</p>
                  <p class="text2 shsj">权限功能说明：使用语音输入、语音搜索、网络电话服务</p>
                  <p class="text2 shsj">使用场景或目的：社交使用，识别您的购物需求以及客服与售后需求</p>
                  <p class="text2 shsj">权限类型：日历</p>
                  <p class="text2 shsj">权限名称：NSCalendarsUsageDescription</p>
                  <p class="text2 shsj">权限功能说明：编辑、添加您关注的直播、活动等日程</p>
                  <p class="text2 shsj">使用场景或目的：用于识别日历中添加关注直播、活动的日程并提醒</p>
                  <p class="text2 shsj">权限类型：蓝牙</p>
                  <p class="text2 shsj">权限名称：NSBluetoothAlwaysUsageDescription(持续获取)；</p>
                  <p class="text2 shsj">NSBluetoothPeripheralUsageDescription(App使用时)</p>
                  <p class="text2 shsj">权限功能说明：调用蓝牙功能，实现设备连接、匹配</p>
                  <p class="text2 shsj">使用场景或目的：小程序平台第三方服务可调用您的蓝牙功能，实现设备连接、匹配</p>
                  <p class="text2 shsj">权限类型：通讯录</p>
                  <p class="text2 shsj">权限名称：NSContactsUsageDescription</p>
                  <p class="text2 shsj">权限功能说明：访问通讯录信息</p>
                  <p class="text2 shsj">使用场景或目的：自动填写联系人信息，获取好友信息</p>
                  <p class="text2 shsj">权限类型：面容ID/触控ID</p>
                  <p class="text2 shsj">权限名称：NSFaceIDUsageDescription</p>
                  <p class="text2 shsj">权限功能说明：访问面容信息或指纹信息</p>
                  <p class="text2 shsj">使用场景或目的：使用面容解锁、支付服务</p>
                  <p class="text2 shsj">权限名称：NSUserTrackingUsageDescription</p>
                  <p class="textTitle shsj">请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法继续为您提供该权限所对应的服务。您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</p>
                  <p class="textTitle shsj">（三）我们从第三方获得您个人信息的情形</p>
                  <p class="text2 shsj">我们可能从第三方获取您授权共享的账号信息（头像、昵称及授权页面提示的其他信息），并在您同意本隐私政策后将您的第三方账号与您的德财院账号绑定，使您可以通过第三方账号直接登录并使用我们的产品与/或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。</p>
                  <p class="textTitle shsj">（四）您个人信息使用的规则</p>
                  <p class="text2 shsj">1、我们会根据本隐私政策的内容，为实现我们的产品与/或服务功能对所收集的个人信息进行使用。</p>
                  <p class="text2 shsj">2、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理。</p>
                  <p class="text2 shsj">3、当我们展示您的个人信息时，我们会采用包括去标识化或者匿名化处理方式对您的信息进行脱敏，以保护您的信息安全。</p>
                  <p class="text2 shsj">4、当我们要将您的个人信息用于本隐私政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会事先征求您的明示同意。</p>
                  <p class="textTitle shsj">请您理解，我们向您提供的产品与/或服务将不断更新变化。如果您选择使用本隐私政策中尚未列明的其他产品与/或服务时，我们会在收集您的个人信息前通过协议、页面提示等方式向您详细说明信息收集的目的、方式、范围并征求您的同意。若您不同意提供前述信息，您可能无法使用该项产品与/或服务，但不影响您使用现有产品与/或服务。</p>
                  <p class="textTitle shsj">二、我们如何使用Cookies和同类技术</p>
                  <p class="textTitle shsj">（一）Cookies的使用</p>
                  <p class="text2 shsj">1、为实现您联机体验的需求，使您获得更轻松的访问体验。我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件，指定给您的Cookies是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤、存储您偏好或您购买的商品等数据进而为您提供偏好设置、帮助您优化选择与互动、帮助判断您的登录状态以及账号或数据安全。</p>
                  <p class="text2 shsj">2、我们不会将Cookies用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookies您可以清除计算机上保存的所有Cookies，大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookies；另外，您也可以清除软件内保存的所有Cookies。但如果您这么做，您可能需要在每一次访问德财院APP/网站时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。</p>
                  <p class="textTitle shsj">（二）网络Beacon和同类技术的使用</p>
                  <p class="text2 shsj">除Cookies外，我们可能还会在网站上使用网络Beacon等其他同类技术。我们的网页上常会包含一些电子图像（称为"单像素"GIF文件或"网络Beacon"）。我们使用网络Beacon的方式有<span class="textTitle">：（1）通过在德财院APP/网站上使用网络Beacon，计算用户访问数量，并通过访问Cookies辨认注册的德财院用户。（2）通过得到的Cookies信息，为您提供服务。</span></p>
                  <p class="textTitle shsj">三、我们如何对外提供您的个人信息</p>
                  <p class="textTitle shsj">（一）共享</p>
                  <p class="textTitle shsj">1、我们不会与德财院以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：</p>
                  <p class="text2 shsj">（1）事先获得您明确的同意或授权；</p>
                  <p class="text2 shsj">（2）根据法律法规、行政及司法部门强制性要求进行提供；</p>
                  <p class="text2 shsj">（3）在法律法规允许的范围内，为维护德财院、德财院的关联方或合作伙伴、您或其他德财院用户或社会公众利益、财产或安全免遭损害而有必要提供；</p>
                  <p class="text2 shsj">（4）只有共享您的个人信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务；</p>
                  <p class="text2 shsj">（5）应您需求为您处理您与他人的纠纷或争议；</p>
                  <p class="text2 shsj">（6）符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</p>
                  <p class="text2 shsj">（7）基于学术研究而使用；</p>
                  <p class="text2 shsj">（8）基于符合法律法规的社会公共利益、突发公共卫生事件而使用。</p>
                  <p class="textTitle shsj">2、为了提高服务质量，保障德财院相关功能的实现和应用的安全稳定运行，完善用户体验，向您提供相关产品或服务，向您展示可能有意向的内容，保护您的账号与交易安全，您的个人信息可能与以下第三方进行共享，我们会接入由第三方提供的软件开发包（SDK）实现该目的，具体第三方SDK列表说明如下：</p>
                  <p class="text2 shsj">我们会对第三方SDK进行严格的安全检测，并要求合作伙伴采取严格的措施来保护您的个人数据。在满足新的服务需求及业务功能变更时，我们可能会调整我们接入的第三方SDK，并及时在本说明中向您公开说明接入第三方SDK的最新情况。请注意，第三方SDK可能因为版本升级、策略调整等原因导致数据类型存在一些变化，附其官方网站链接或相关隐私保护说明链接供参考，具体请以其公示的官方说明为准。</p>
                  <p class="text2 shsj">产品/类型：极光推送</p>
                  <p class="text2 shsj">使用目的：推送消息</p>
                  <p class="text2 shsj">使用场景：消息提醒更新时</p>
                  <p class="text2 shsj">收集信息：MAC地址、ANDROID_ID、IMSI、bssid、IMEI、设备序列号、软件安装列表、软件运行列表、读取已安装包名列表</p>
                  <p class="text2 shsj">收集信息使用目的：为android用户提供消息推送并实现⽤户分群推送功能，提升推送送达率</p>
                  <p class="text2 shsj">SDK用途：为APP用户提供信息推送服务</p>
                  <p class="text2 shsj">处理个人信息类型：设备标识符(包括IMEI 、IDFA 、AndroidID 、GAID 、MAC 、OAID 、IMSI 、UAID)、 设备硬件信息(包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称)、操作系统信息(包括操作系 统版本、系统名称、系统语⾔)、⽹络信息(包括⽹络类型、运营商名称、基站信息、IP地址、WiFi信息、 SSID 、BSSID)、推送信息⽇志、位置相关信息 、软件安装列表、软件运行列表、读取已安装包名列表</p>
                  <p class="text2 shsj">共享方式：SDK采集、接口传输（config.jpush.cn、fcapi.jpush.cn、config-junion.jpush.cn、tsis.jpush.cn、ce3e75d5.jpush.cn、stats.jpush.cn、bjuser.jpush.cn、pushstyle.jpush.cn、cn.jpush.android）</p>

                  <p class="text2 shsj">第三方公司名称：深圳市和讯华谷信息技术有限公司</p>
                  <p class="text2 shsj">隐私保护说明：https://www.jiguang.cn/license/privacy</p>
                  <p class="text2 shsj">产品/类型：百度移动统计</p>
                  <p class="text2 shsj">使用目的：了解用户的使用情况，进行数据分析，以改善产品服务</p>
                  <p class="text2 shsj">官网链接：https://mtj.baidu.com/web/welcome/login/</p>
                  <p class="text2 shsj">隐私政策链接：https://tongji.baidu.com/web/help/article?id=330&type=0</p>
                  <p class="text2 shsj">调用的权限：读取/写入外部存储卡；获取位置；获取运行的任务列表；查看WLAN连接；读取手机状态和身份；使用蓝牙收集个人信息类型：网络信息与包含ICCI、IMSI、IMEI、MAC地址在内的设备信息；Wi-Fi地址；MAC地址；已安装应用列表；蓝牙状态安卓操作系统第三方SDK列表</p>
                  <p class="text2 shsj">产品/类型：联通（联通一键登录）</p>
                  <p class="text2 shsj">使用目的：获取手机号进行一键登录</p>
                  <p class="text2 shsj">使用场景：用户进行登录时</p>
                  <p class="text2 shsj">个人信息收集类型：手机号、私网ipv4地址</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，不涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：中国联合网络通信集团有限公司</p>
                  <p class="text2 shsj">隐私保护说明：https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true</p>
                  <p class="text2 shsj">产品/类型：移动一键登录（中国移动认证，个验）</p>
                  <p class="text2 shsj">使用目的：用于第三方登录、验证码登录</p>
                  <p class="text2 shsj">使用场景：用户登录时</p>
                  <p class="text2 shsj">个人信息收集类型：imsi、网络类型、网络制式、设备类型、系统版本、剪切板，设备版本</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，不涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：中国移动通信集团有限公司</p>
                  <p class="text2 shsj">隐私保护说明：https://wap.cmpassport.com/resources/html/contract.html</p>
                  <p class="text2 shsj">产品/类型：微信开放平台</p>
                  <p class="text2 shsj">使用目的：用于快速登录、支付、分享等功能</p>
                  <p class="text2 shsj">使用场景：用户进行登录时，用户进行微信支付时，将页面分享至微信好友或朋友圈时</p>
                  <p class="text2 shsj">个人信息收集类型：个人常用设备信息、设备识别信息</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，不涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：深圳市腾讯计算机系统有限公司</p>
                  <p class="text2 shsj">隐私保护说明: https://privacy.qq.com/document/priview/bdf936b2477a45ff86da57e3d988bc2b</p>
                  <p class="text2 shsj">产品/类型：腾讯开放平台（QQ、QQ互联）</p>
                  <p class="text2 shsj">使用目的：用于分享功能</p>
                  <p class="text2 shsj">使用场景：用户进行登录时，将页面分享至QQ好友或朋友圈时</p>
                  <p class="text2 shsj">个人信息收集类型：个人常用设备信息、设备识别信息</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，不涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：深圳市腾讯计算机系统有限公司</p>
                  <p class="text2 shsj">隐私保护说明：https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e</p>
                  <p class="text2 shsj">产品/类型：新浪通行证（微博SDK）</p>
                  <p class="text2 shsj">使用目的：分享信息至微博</p>
                  <p class="text2 shsj">使用场景：将信息分享至微博时</p>
                  <p class="text2 shsj">个人信息收集类型：MAC地址、IMEI、设备序列号</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，不涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：北京微梦创科网络技术有限公司</p>
                  <p class="text2 shsj">隐私保护说明：https://open.weibo.com/wiki/Android_SDK%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3</p>
                  <p class="text2 shsj">产品/类型：小米推送</p>
                  <p class="text2 shsj">使用目的：用于消息推送</p>
                  <p class="text2 shsj">使用场景：用户账号相关活动、消息提醒更新时</p>
                  <p class="text2 shsj">个人信息收集类型：设备唯一标识码、网络状态、网络制式、设备序列号</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，不涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：小米科技有限责任公司</p>
                  <p class="text2 shsj">隐私保护说明：https://dev.mi.com/console/doc/detail?pId=1822</p>
                  <p class="text2 shsj">产品/类型：华为HMS-Core（华为推送、华为应用升级）</p>
                  <p class="text2 shsj">使用场景：用户账号相关活动、消息提醒更新时</p>
                  <p class="text2 shsj">个人信息收集类型：设备唯一标识码、设备序列号</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，不涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：华为技术有限公司</p>
                  <p class="text2 shsj">隐私保护说明：https://developer.huawei.com/consumer/cn/devservice/term/产品/类型：魅族推送</p>
                  <p class="text2 shsj">使用目的：用于消息推送</p>
                  <p class="text2 shsj">使用场景：用户账号相关活动、消息提醒更新时</p>
                  <p class="text2 shsj">个人信息收集类型：当前流量卡、匿名用户ID（OAID）、IMSI、位置信息、设备序列号</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，不涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：魅族科技有限公司</p>
                  <p class="text2 shsj">隐私保护说明：https://www.meizu.com/legal.html</p>
                  <p class="text2 shsj">产品/类型：Vivo</p>
                  <p class="text2 shsj">使用目的：用于消息推送</p>
                  <p class="text2 shsj">使用场景：用户账号相关活动、消息提醒更新时</p>
                  <p class="text2 shsj">个人信息收集类型：匿名用户ID（OAID）</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，不涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：维沃移动通信有限公司</p>
                  <p class="text2 shsj">隐私保护说明：https://dev.vivo.com.cn/documentCenter/doc/366</p>
                  <p class="text2 shsj">产品/类型：ColorOS</p>
                  <p class="text2 shsj">使用场景：用户账号相关活动、消息提醒更新时</p>
                  <p class="text2 shsj">个人信息收集类型：匿名用户ID（OAID）</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，不涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：OPPO广东移动通信有限公司</p>
                  <p class="text2 shsj">隐私保护说明：https://security.oppo.com/cn/privacy.html</p>
                  <p class="text2 shsj">产品/类型：腾讯TBS浏览服务</p>
                  <p class="text2 shsj">使用目的：加载网页页面，浏览pdf文件</p>
                  <p class="text2 shsj">使用场景：打开网页页面时</p>
                  <p class="text2 shsj">个人信息收集类型：Wifi信息、MAC地址、IMSI、bssid、IMEI、设备序列号、android_id</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，不涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：深圳市腾讯计算机系统有限公司</p>
                  <p class="text2 shsj">隐私保护说明：https://x5.tencent.com/tbs/policy.html</p>
                  <p class="text2 shsj">产品/类型：ColorOS</p>
                  <p class="text2 shsj">产品类型：腾讯X5浏览器</p>
                  <p class="text2 shsj">使用目的：查看视频课件pdf文件</p>
                  <p class="text2 shsj">官网链接：https://x5.tencent.com/</p>
                  <p class="text2 shsj">调用的权限：读取/写入外置存储卡</p>
                  <p class="text2 shsj">收集个人信息类型：网络信息与包含ICCI、IMSI、IMEI、MAC地址在内的设备信息；Wi-Fi地址；MAC地址</p>
                  <p class="text2 shsj">第三方公司名称：深圳市腾讯计算机系统有限公司</p>
                  <p class="text2 shsj">产品/类型：友盟分享</p>
                  <p class="text2 shsj">使用目的：帮助用户更好的向各个平台分享内容</p>
                  <p class="text2 shsj">使用场景：将页面分享至QQ，微信以及微博时</p>
                  <p class="text2 shsj">个人信息收集类型：Wifi信息、MAC地址、IMSI、bssid、IMEI、设备序列号、android_id</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：北京锐讯灵通科技有限公司</p>
                  <p class="text2 shsj">隐私保护说明：https://www.umeng.com/page/policy?spm=a213m0.22488127.0.0.3cb275efBZHKoQ</p>
                  <p class="text2 shsj">产品/类型：支付宝支付</p>
                  <p class="text2 shsj">使用目的：用于支付</p>
                  <p class="text2 shsj">使用场景：使用支付宝支付时</p>
                  <p class="text2 shsj">个人信息收集类型：基础设备信息、app信息</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，不涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：支付宝（杭州）信息技术有限公司</p>
                  <p class="text2 shsj">隐私保护说明：https://render.alipay.com/p/c/k2cx0tg8</p>
                  <p class="text2 shsj">产品/类型：微信支付</p>
                  <p class="text2 shsj">使用目的：帮助用户使用微信支付服务</p>
                  <p class="text2 shsj">官网链接：https://open.weixin.qq.com/</p>
                  <p class="text2 shsj">隐私政策链接：https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy</p>
                  <p class="text2 shsj">调用的权限：查看WLAN连接；读取手机状态和身份；检索正在运行的应用；读取MAC地址</p>
                  <p class="text2 shsj">收集个人信息类型：网络信息与包含ICCI、IMSI、IMEI、MAC地址在内的设备信息；Wi-Fi地址；MAC地址；已安装应用列表</p>
                  <p class="text2 shsj">产品/类型：bugly</p>
                  <p class="text2 shsj">使用目的：应用异常上报，帮助开发者快速发现并解决异常</p>
                  <p class="text2 shsj">使用场景：应用异常崩溃时</p>
                  <p class="text2 shsj">个人信息收集类型：基础设备信息、app信息</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：深圳市腾讯计算机系统有限公司</p>
                  <p class="text2 shsj">隐私保护说明：https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</p>
                  <p class="text2 shsj">产品/类型：对象存储OSS</p>
                  <p class="text2 shsj">使用目的：使用目的：经用户选择文件并同意后，帮助用户上传媒体文件至阿里云</p>
                  <p class="text2 shsj">使用场景：上传文件时</p>
                  <p class="text2 shsj">个人信息收集类型：基础设备信息、app信息</p>
                  <p class="text2 shsj">收集方式：SDK本机采集，涉及数据共享</p>
                  <p class="text2 shsj">第三方公司名称：阿里云计算有限公司</p>
                  <p class="text2 shsj">隐私保护说明：http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.21207967.J_9220772140.78.461a3d8ftTOpTC</p>
                  <p class="textTitle shsj">请您注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至敏感个人信息。请您共享时谨慎考虑并决定。</p>
                  <p class="textTitle shsj">（二）委托处理</p>
                  <p class="text2 shsj">我们可能委托授权合作伙伴处理您的个人信息，以便向您提供相应的产品或服务。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供产品或服务所必要的个人信息。如果我们的合作伙伴将您的个人信息用于我们未委托的用途，其将单独征得您的同意。</p>
                  <p class="text2 shsj">我们的合作伙伴包括以下类型：</p>
                  <p class="text2 shsj">（1）提供技术服务的供应商。我们可能会将您的个人信息提供给支持我们功能的第三方，包括为我们提供基础设施技术服务、数据分析服务及数据处理服务等的供应商。</p>
                  <p class="text2 shsj">（2）广告、分析服务类合作伙伴。我们会遵守法律法规及行业通用安全技术，委托这些合作伙伴处理与广告投放、覆盖面和有效性相关的信息。</p>
                  <p class="text2 shsj">对我们委托合作伙伴处理个人信息的，我们会与其签署数据保护协议，要求其按照协议约定、本隐私政策以及相关法律法规要求来处理个人信息。为了保障数据在第三方安全可控，我们推出了云鼎服务，在云端提供安全可靠的数据使用和存储环境，确保用户数据的安全性。</p>
                  <p class="textTitle shsj">（三）转移</p>
                  <p class="text2 shsj">在因合并、分立、解散、被宣告破产等原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式，要求接收您个人信息的公司、组织继续受本隐私政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。</p>
                  <p class="textTitle shsj">（四）公开披露</p>
                  <p class="text2 shsj">我们仅会在以下情况，且在采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：（1）根据您单独同意的授权范围披露相应个人信息；（2）如果您严重违反法律法规或者相关协议、规则，我们可能会披露您的相关违规行为及我们对您采取的措施。</p>
                  <p class="textTitle shsj">四、我们如何保护和保存您的个人信息</p>
                  <p class="textTitle shsj">（一）我们保护您个人信息的技术与措施</p>
                  <p class="text2 shsj">我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：</p>
                  <p class="textTitle shsj">1、数据安全技术措施</p>
                  <p class="text2 shsj">我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。例如：德财院的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全；德财院采取加密技术对用户个人信息进行加密保存，并通过隔离技术进行隔离；在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换、SHA256在内多种数据脱敏技术增强个人信息在使用中安全性；德财院采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用；德财院采用代码安全自动检查、数据访问日志分析技术进行个人信息安全审计。</p>
                  <p class="textTitle shsj">2、德财院为保护个人信息采取的其他安全措施</p>
                  <p class="text2 shsj">德财院通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用；通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制；德财院建立信息保护专职部门、数据安全应急响应组织来推进和保障个人信息安全。</p>
                  <p class="text2 shsj">我们存储您个人信息的底层云技术取得了数据中心联盟颁发的“可信云”认证三级认证、通过了公安部安全等级保护三级认证，同时还获得了ISO27000认证。我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
                  <p class="text2 shsj">我们仅允许有必要知晓这些信息的德财院及德财院关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。</p>
                  <p class="text2 shsj">互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。在通过德财院与第三方进行网上产品与/或服务的交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址等。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。</p>
                  <p class="textTitle shsj">3、安全事件处置</p>
                  <p class="text2 shsj">为应对个人信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。</p>
                  <p class="text2 shsj">一旦发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。同时，我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
                  <p class="text2 shsj">如果您对我们的个人信息保护有任何疑问，可通过本隐私政策中约定的联系方式联系我们。<span class="textTitle">如您发现自己的个人信息泄密，尤其是您的账号及密码发生泄露，请您立即通过本隐私政策“八、如何联系我们”中明确的联系方式联络我们，以便我们采取相应措施。</span></p>
                  <p class="textTitle shsj">（二）您个人信息的保存</p>
                  <p class="text2 shsj">1、您的个人信息将存储于中华人民共和国境内。如您使用跨境交易服务，且需要向境外传输您的个人信息完成交易的，我们会单独获取您的授权同意并要求接收方按照双方签署的数据保护协议、本隐私政策以及相关法律法规要求来处理您的个人信息。</p>
                  <p class="text2 shsj">2、在您使用我们的产品与/或服务期间，您的个人信息将在为了实现本政策所述目的之期限内保存，同时将结合法律有强制的留存要求期限的规定确定，如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。在超出保存期间后，我们会根据适用法律的要求删除您的个人信息，或进行匿名化处理。</p>
                  <p class="text2 shsj">3、请您注意，当您成功注销德财院账号后，我们会根据适用法律的要求删除您的个人信息，或进行匿名化处理。</p>
                  <p class="text2 shsj">4、如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</p>
                  <p class="textTitle shsj">五、您如何管理您的个人信息</p>
                  <p class="text2 shsj">德财院非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：</p>
                  <p class="textTitle shsj">1、访问和更正您的个人信息</p>
                  <p class="text2">除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：</p>
                  <p class="text2 shsj">（1）您的浏览信息：您可以访问或清除您的搜索历史记录、查看和修改以及管理其他数据，对于您在使用我们的产品与/或服务过程中产生的其他个人信息需要访问或更正，请随时联系我们。我们会根据本隐私政策所列明的方式和期限响应您的请求。</p>
                  <p class="text2 shsj">（2）您的订单信息：PC端您可以通过访问“我的订单”页面查看您的所有已经完成、待付款或待售后的订单。移动端具体路径为：移动端首页--“我的”进入我的订单。您可以选择删除已经完成和已取消的订单来删除您的订单信息，但这样可能导致我们无法准确判断您的购买信息而难以提供相应的售后服务，您也无法对删除的订单使用我们的晒单和评价功能。</p>
                  <p class="textTitle shsj">2、删除您的个人信息</p>
                  <p class="text2 shsj">您在我们的产品与/或服务页面中可以直接清除或删除的信息，包括订单信息、浏览信息。</p>
                  <p class="textTitle">在以下情形中，您可以向我们提出删除个人信息的请求：</p>
                  <p class="text2 shsj">（1）如果我们处理个人信息的行为违反法律法规；</p>
                  <p class="text2 shsj">（2）如果我们收集、使用您的个人信息，却未征得您的同意；</p>
                  <p class="text2 shsj">（3）如果我们处理个人信息的行为严重违反了与您的约定；；</p>
                  <p class="text2 shsj">（4）如果您不再使用我们的产品或服务，或您注销了德财院账号；</p>
                  <p class="text2 shsj">（5）如果我们终止服务及运营，或者保存期限已届满。</p>
                  <p class="text2 shsj">若我们决定响应您的删除请求，我们还将同时尽可能通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体已获得您的独立授权。</p>
                  <p class="textTitle shsj">请您注意，当您成功注销德财院账号后，我们将对您的个人信息进行删除或匿名化处理。当您或我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到可以删除或实现匿名化。</p>
                  <p class="textTitle shsj">3、改变您授权同意的范围或撤回您的授权</p>
                  <p class="textTitle shsj">您可以通过删除信息、关闭设备功能、在德财院网站或软件中进行隐私设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账号的方式，撤回我们继续收集您个人信息的全部授权。</p>
                  <p class="textTitle shsj">请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
                  <p class="textTitle shsj">4、注销账号</p>
                  <p class="textTitle shsj">您可以在我们的产品中直接申请注销账号。您可以通过移动端APP访问“我的—系统设置-账户与安全-注销设备”完成账号注销。关于您注销账号的方式以及您应满足的条件，请详见<span style="color:red;">《德财院账号注销须知》</span>。您注销账号后，我们将停止为您提供产品与/或服务，并根据适用法律的要求删除您的个人信息，或进行匿名化处理。</p>
                  <p class="textTitle shsj">5、获取您的个人信息副本</p>
                  <p class="text2 shsj">您有权获取您的个人信息副本。如您需要获取我们收集的您的个人信息副本，您随时联系我们。在符合相关法律规定且技术可行的前提下，我们将根据您的要求向您提供相应的个人信息副本。</p>
                  <p class="textTitle shsj">6、响应您的请求</p>
                  <p class="text2 shsj">如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品与/或服务时所产生的其他个人信息或者获取个人信息副本，或您认为德财院存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以通过本隐私政策中的方式与我们联系。为了保障安全，我们可能需要您提供书面请求，或提供您的身份证明文件，我们将在收到您反馈并验证您的身份后的15天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>
                  <p class="textTitle shsj">六、未成年人的个人信息保护</p>
                  <p class="text2 shsj">1、德财院非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您监护人的同意。德财院根据国家相关法律法规的规定保护未成年人的个人信息。</p>
                  <p class="text2 shsj">2、我们不会主动直接向未成年人收集其个人信息。对于经监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、监护人同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</p>
                  <p class="text2 shsj">3、如果有事实证明未成年人在未取得监护人同意的情况下注册使用了我们的产品与/或服务，我们会与相关监护人协商，并设法尽快删除相关个人信息。</p>
                  <p class="text2 shsj">4、对于可能涉及的不满14周岁的儿童个人信息，我们进一步采取以下措施予以保障：</p>
                  <p class="text2 shsj">（1）对于收集到的儿童个人信息，我们除遵守本隐私政策关于用户个人信息的约定外，还会秉持正当必要、知情同意、目的明确、安全保障、依法利用的原则，严格遵循《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露，且不会超过实现收集、使用目的所必须的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。我们会指定专人负责儿童个人信息保护事宜。我们还会制定儿童个人信息保护的内部专门制度。</p>
                  <p class="text2 shsj">（2）当您作为监护人为被监护的儿童选择使用德财院相关服务时，我们可能需要向您收集被监护的儿童个人信息，用于向您履行相关服务之必要。在具体服务中需要向您收集儿童个人信息的，我们会事先取得您的授权同意，并告知您收集的目的和用途。如果您不提供前述信息，您将无法享受我们提供的相关服务。此外，您在使用晒单、评价及问答功能分享商品相关信息时可能会主动向我们提供儿童个人信息，请您明确知悉并谨慎选择。您作为监护人应当正确履行监护职责，保护儿童个人信息安全。若儿童本人需要注册或使用我们的产品与/或服务，您应正确引导并予以监护。</p>
                  <p class="text2 shsj">（3）儿童或其监护人有权随时访问和更正儿童个人信息，还可以向我们提出更正和删除的请求。如您对儿童个人信息相关事宜有任何意见、建议或投诉、举报，请联系我们。我们会随时为您提供帮助。</p>
                  <p class="textTitle shsj">七、通知和修订</p>
                  <p class="text2 shsj">1、为给您提供更好的服务以及随着德财院业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在德财院网站、德财院移动端上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问德财院以便及时了解最新的隐私政策。</p>
                  <p class="text2 shsj">2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。</p>
                  <p class="text2 shsj">本隐私政策所指的重大变更包括但不限于：</p>
                  <p class="text2 shsj">（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
                  <p class="text2 shsj">（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
                  <p class="text2 shsj">（3）个人信息共享、转移或公开披露的主要对象发生变化；</p>
                  <p class="text2 shsj">（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
                  <p class="text2 shsj">（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
                  <p class="text2 shsj">（6）个人信息安全影响评估报告表明存在高风险时。</p>
                  <p class="text2 shsj">3、我们还会将本隐私政策的旧版本存档，供您查阅。</p>
                  <p class="text2 shsj">4、为了您能及时接收到通知，建议您在联系方式更新时及时通知我们。如您在本政策更新生效后继续使用我们的服务，即代表您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。我们鼓励您在每次使用我们服务时都查阅本政策。您可以在德财院APP通过“我的-账户设置-关于德财院APP-隐私政策”中查看本政策。</p>
                  <p class="textTitle shsj">八、如何联系我们</p>
                  <p class="text2 shsj">1、如您对本隐私政策或您个人信息的相关事宜或者投诉、举报、有任何问题、意见或建议，请通过以下方式与我们联系。</p>
                  <p class="text2 shsj">联系电话：0755-25885666</p>
                  <p class="text2 shsj">联系地址：深圳市罗湖区笋岗街道洪湖二街50号新南滨大楼6楼</p>
                  <p class="text2 shsj">2、一般情况下，我们将在15天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报。</p>
                  <p class="text2 shsj">附：<span class="textTitle">个人信息及敏感个人信息示例（非德财院APP或网站所收集的个人信息，仅作示例说明）</span></p>
                  <p class="text2 shsj">个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。（本定义出自于《中华人民共和国个人信息保护法》）。</p>
                
                
                
                
                </li>
                <!-- <li>
                  <p class="textTitle">一、我们如何收集个人信息</p>
                  <p class="text2">
                    为了您可以正常使用我们的服务，我们会在下列情形下收集您的相关个人信息，同时也可能通过合法存储您相关信息的第三方收集您的个人信息：
                  </p>
                  <p class="mintitle">1、账户注册</p>
                  <p class="text2">
                    您在注册德讯证顾账户或使用德讯证顾服务时，可能需要提供您的姓名、身份证信息、联系方式（电话号码及电子邮箱）、地址，以便完成账户注册并正常使用我们的相关服务。
                  </p>
                  <p class="mintitle">2、信息收集与风险防范</p>
                  <p class="text2">
                    为了遵守中国法律规定，保障您的账户安全，防止个人信息泄露，提升用户体验，我们可能会收集您的下列信息：
                  </p>
                  <p class="text2">
                    （1）日志信息：我们会收集您在使用我们服务时搜索或浏览的信息、通讯的信息、分享内容所包含的信息以及设备和软件信息，其中设备和软件信息包括您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码等；
                  </p>
                  <p class="text2">
                    （2）位置信息：为了更好地保护您的账户安全，我们为您提供了异地登录保护功能，以降低造成账户被盗导致损失的可能性。此外，还有快速填写地址功能来提高您的使用效率，如果你需要使用前述服务，您必须同意授权我们通过GPS或WiFi等方式获取位置信息。您也可以通过关闭相应设备的定位功能，停止我们对您位置信息的收集。
                  </p>
                  <p class="text2">
                    （3）设备或应用信息：为保障您的账户安全，我们会在您执行相关操作时，对设备或应用信息包括您的移动设备、网页浏览器或您用于接入我司服务的其他程序所提供的配置信息、您的 IP 地址、无线网络接入信息和您的移动设备所用的版本、硬件型号、设备 MAC 地址、操作系统类型、软件列表唯一设备识别码（如 IMEI / android ID / IDFA / OPENUDID / GUID 、 SIM 卡 IMSI 信息等在内的描述个人常用设备基本情况的信息）进行转发。即便在未登录状态下，也可以获得便捷流畅的体验，并同样可以进行阅读、查看行情等基础行为
                  </p>
                  <p class="text2">
                    为了方便您更便捷地在投资、社群交流中找到好友，同时保障您获取信息的权利与投资者的账户安全，我们需要采集设备号（ IMEI 码）与国际移动用户识别码（ IMSI ）,如果您使用前述服务，您需要统一授权我们来获取。
                  </p>
                  <p class="text2">
                    除了产品的基本功能外，我们提供一些附加功能来提升您的体验，需要提供以下权限与信息：设备权限、位置信息、个人敏感信息。当您使用附加功能时，我们会取得相关权限的同意。您也可以在设备的设置功能中随时选择关闭部分或者全部权限，从而拒绝我们收集或提供相应的个人信息，也不会影响其他功能的使用。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。
                  </p>
                  <p class="text2">
                    （4）在静默或后台运行时，为保障您的账户安全，我们会对设备或应用信息包括您的移动设备、网页浏览器或您用于接入我司服务的其他程序所提供的配置信息、您的 IP 地址、无线网络接入信息和您的移动设备所用的版本、硬件型号、设备 MAC 地址、操作系统类型、软件列表唯一设备识别码（如 IMEI / android ID / IDFA / OPENUDID / GUID 、 SIM 卡 IMSI 信息等在内的描述个人常用设备基本情况的信息）进行收集。
                  </p>
                  <p class="text2">
                    （5）设备权限：在提供服务的过程中，可能需要您开通一些设备权限，我们会通过弹窗等方式请求通知、蓝牙（Android设备）、 WiFi 及蜂窝数据的权限、麦克风、相册或手机存储、摄像头权限；在您更换头像、缓存应用图片或使用图片的上传、保存、识别、编辑功能与分享功能时，会主动提示您获取读写相册或手机存储的权限；在您启动应用后,保存您的信息时会主动提示您获取修改或删除存储卡中的内容权限；在您更换头像或使用合规需要拍照时，会主动提示您获取摄像头的权限；在您需要消息内容推送时，会主动提示您获取通知的权限；在您需要投诉建议及相关功能时，会主动提示麦克风的权限（Android设备）；在您需要使用与访问网络时，会主动提示蓝牙（Android设备）、 WiFi 及蜂窝数据相关权限；在您需要音视频功能时会主动提示麦克风与摄像头的权限。
                  </p>
                  <p class="text2">
                    （6）个人数据信息：除了上述的个人敏感信息之外，为了保障您的账户安全，在您进行登录、找回密码、账户相关服务操作时，可能需要提供指纹及其他个人敏感信息来进行操作，如果使用前述服务需要同意授权我们来获取。
                  </p>
                  <p class="mintitle">3、服务通知及查询</p>
                  <p class="text2">
                    为了您更方便的获得我们的服务通知及查询服务状态，我们会按照法律法规规定对您的身份信息、交易信息、行为信息进行储存并妥善保管，同时也会根据您的查询需求，向您发送相关的服务状态通知。
                  </p>
                  <p class="mintitle">4、cookie等技术</p>
                  <p class="text2">
                      您在使用本平台时，德讯证顾或德讯证顾授权的第三方插件会自动接收并记录用户使用本平台的相关数据，包括IP地址、网站cookie、网卡地址、手机设备号信息。德讯证顾收集和储存您的信息主要目的为提高服务的效率和质量，除您所购产品服务需要和法律法规规定的情形外，未经您的许可德讯证顾不会向第三方公开、透露您的个人信息。您可根据自己的偏好管理或删除cookie，但这一操作在某些情况下可能会影响您安全便捷访问本平台和使用德讯证顾提供的服务。
                  </p>
                  <p class="mintitle">5、专用网络通道</p>
                  <p class="text2">
                    在您通过本平台使用了由第三方提供的服务时，为使您获得更安全的访问体验，尽力确保您的账号安全，我们可能会使用专用网络通道技术，帮助您识别我们已知的高风险站点，减少由此引起的钓鱼或账号泄露等风险，保护您和第三方的共同权益，同时防止不法分子篡改您和您与第三方之间正常访问的服务内容，如广告注入、非法内容篡改等，在此过程中我们可能会获取和保存您计算机的IP、ID等相关信息。
                  </p>
                  <p class="mintitle">6、储存信息</p>
                  <p class="text2">
                    德讯证顾在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。我们将在公司留存或德讯证顾运营期内保存您的个人信息。当您注销账户之后，我们将停止为您提供产品和服务，在满足法律法规或监管机构规定的基础上根据您的要求，即时删除您的个人信息或匿名化处理。如果我们出现停止运营的情况，我们将立即停止收集您个人信息的行为，将停止运营的通知逐一送达或公告的形式通知您，在满足法律法规或监管机构规定的基础上，对所持有的您的个人信息进行删除或匿名化处理。
                  </p>

                  <p class="mintitle">
                    7、在法律法规允许的范围内，在以下情形中，我们可能会在无需征得您同意的情况下收集
                    并使用您的个人信息：
                  </p>
                  <p class="text2">（1）依照国家法律法规相关的规定；</p>
                  <p class="text2">
                    （2）依照公检法等执法部门法律程序相关的要求；
                  </p>
                  <p class="text2">
                    （3）依照政府部门、上级监管单位相关的制度；
                  </p>
                  <p class="text2">
                    （4）为维护社会公共利益，保护我们的公司、我们的用户或雇员的合法权益所合理必需的
                    其他用途。
                  </p>
                </li>
                <li>
                  <p class="textTitle">二、我们如何使用个人信息</p>
                  <p class="text2">
                    我们承诺对您的信息进行保密，我们会在以下情形使用您的个人信息：
                  </p>
                  <p class="text2">
                    1、遵守国家法律法规及监管规定，为顺利向您提供服务，或提升您的服务体验，实现本政
                    策中“我们如何收集个人信息”章节所述目的。
                  </p>
                  <p class="text2">
                    2、向您发送商业性电子信息，或提供与您相关的产品信息。如您不希望接此类内容，您可
                    通过回复短信退订以拒绝该类短信。
                  </p>
                  <p class="text2">
                    3、共享：在和第三方（如与德讯证顾关联公司、德讯证顾供应商等组织机构）共享您的个人信息前，我们会对其个人信息安全防护能力水平提出要求，确认其采集个人信息行为的合法性、正当性、安全性、必要性，与其签订保密协议，对其查询行为及进行监控，督促其遵守国家法律法规及协议中约定的安全防护措施和保密条例，一旦发现其违反协议约定将会采取有效措施甚至终止合作。以下情形会共享您的个人信息：
                  </p>
                  <p class="text2">（1）经过您的明确授权或同意的；</p>
                  <p class="text2">
                    （2）为了提供需要和第三方共享信息才能提供的服务；
                  </p>
                  <p class="text2">
                    （3）为了处理您的交易纠纷或争议，需要与银行或交易方共享交易信息；
                  </p>
                  <p class="text2">
                    （4）公司进行合并、被收购、IPO
                    及其它资本活动时，我们会把您的个人信息共享给必要的主体，并要求其签署保密协议；
                  </p>
                  <p class="text2">
                    （5）在国家法律法规允许的范围内，授权已取得您明确同意的第三方向我们查询、采集您
                    在德讯证顾的个人信息。
                  </p>
                  <p class="text2">
                    （6）为了提高服务质量，完善用户体验，我们集成了百度统计SDK。当您同意本隐私政策后，百度统计SDK会收集、使用您的网络信息与包含ICCI、IMSI、IMEI、MAC地址在内的设备信息，用于提升产品质量，提高用户体验。
                  </p>
                  <p class="text2">
                    （7）当您同意本隐私政策后，百度统计SDK会在静默或后台运行时使用您的网络信息与包含ICCI、IMSI、IMEI、MAC地址在内的设备信息，用于提升产品质量，提高用户体验。
                  </p>
                  <p class="text2" style="padding-left:10px;">目前我们接入的第三方SDK服务主要包括以下几种类型：</p>
                  <p class="text2">● 进行用户行为数据上报分析；</p>
                  <p class="text2">● 提供支付服务；</p>
                  <p class="text2">● 进行程序crash信息上报；</p>
                  <p class="text2">● 进行性能统计；</p>
                  <p class="text2">● 用于广告统计及监控；</p>
                  <p class="text2">● 用于第三方帐号登录；</p>
                  <p class="text2">● 用于便于您分享德讯证顾内容至第三方平台；</p>
                  <p class="text2">
                    该等接入第三方服务由相关方负责运营，须受第三方自己的服务条款及信息保护声明（而非本《隐私政策》）约束。关于第三方SDK具体调用的设备权限类型，以及如何收集、使用您的个人信息，建议您参考第三方SDK的相关服务协议及隐私政策。如果您希望进一步了解我们所接入的第三方SDK情况，请您阅读<span class="active" @click="jump">第三方SDK情况说明。</span></p>
                  <p class="text2">
                    4、转让：未经您的授权或同意，我们不会将您的个人信息转让给任何组织和个人，但是涉及到公司合并、收购或破产清算时，有可能会将您的个人信息转让给新的组织，届时，我们
                    会要求其以通知确认的形式征求您的同意，并要求其遵守本隐私政策。
                  </p>
                  <p class="text2">
                    5、公示：未经您的授权或同意，原则上我们不会公开披露您的个人信息，但在公布中奖活
                    动名单的情况下，需要公示的中奖用户登录名以及脱敏后的中奖用户手机号码除外。
                  </p>
                  <p class="text2">
                    6、当我们需要将您的个人信息用于法律允许的其他必要用途时，我们会在通知并征得您的
                    同意后进行。
                  </p>
                </li>
                <li>
                  <p class="textTitle">三、您如何访问和控制自己的个人信息</p>
                  <p class="text2">
                    依据中国法律法规及监管规定，我司保障您对个人信息进行访问和控制的权利：
                  </p>
                  <p class="text2">
                    您可通过本平台上“我的”及类似含义的功能路径，查阅您的个人资料信息、账户信息，修改您的个人资料，或进行相关的隐私、安全设置；出于安全性和身份识别的考虑或根据法律法规的强制规定，您可能无法修改注册时提供的初始注册信息。如果您申请注销德讯证顾账户，提交注销申请后即时生效，我们会将该账户内的所有信息清空，并不再收集、使用或共享与该账户相关的所有个人信息，根据相关法律法规的要求，我们需要在规定的时间内对您的历史信息另行保存，相关监管部门有权依法进行查询。此外，您可以通过我们的客服热线：400-6368688 进行个人信息错误修正或注销账户申请。
                  </p>
                </li>
                <li>
                  <p class="textTitle">四、我们如何保护您的个人信息</p>

                  <p class="text2 text2_padding">
                    <span class="text2_block">● </span>
                    <span style="display:block;">
                    德讯证顾已使用符合业界标准的安全措施保护您的个人信息，并加强了员工对保护个人信息重要性的认识；同时请您理解，由于技术水平局限以及可能存在的恶意攻击，有可能出现德讯证顾无法合理预见、防范、控制的以外情况。如发生个人信息安全事件，德讯证顾将按照法律法规要求，及时将有关情况以电话、推送通知及其他有效方式告知您，同时将依据监管规定上报个人信息安全处置情况。</span>
                  </p>
                  <p class="text2 text2_padding">
                    <span class="text2_block">● </span>
                    <span style="display:block;">
                      我们非常重视未成年人的个人信息的保护，如果您为未成人，建议您在父母或监护人的指导下阅读本政策，并在取得您的父母或监护人同意的前提下向我们提供您的相关信息以便使用我们的相关服务。</span>
                  </p>

                </li>
                <li>
                  <p class="textTitle">五、本隐私政策的例外</p>
                  <p class="text2">
                    本政策仅适用于我们所收集的相关信息。您在我们的服务过程中，可能会链接到第三方网站或使用到我们接入的第三方服务，该等服务内容由相关的第三方运营并提供，您使用该等服务的时候，如涉及向第三方提供的任何个人信息，请您在使用前仔细阅读该第三方的隐私保护协议的相关内容或直接联系第三方获得他们的隐私保护协议的详细情况。
                  </p>
                </li>
                <li>
                  <p class="textTitle">六、本政策的修订及变更</p>
                  <p class="text2">
                    为更好的提供服务，根据用户需求、业务规则以及法律法规的要求，德讯证顾会不时地对本政策的相关条款进行修改，修改后的内容会通过本平台等有效渠道公布，并取代此前相关内容。您应不时关注相关公告、提示信息及协议内容的变动，若您不同意更新后的内容，应立即停止使用相应服务，并注销相关账户，我司将停止收集您的个人信息；如您继续使用服务，即视为同意接受变动内容。
                  </p>
                </li>
                <li>
                  <p class="text_title">● 如何联系我们</p>
                  <p class="text2">
                    1、如果您对我本政策有任何疑问、意见或建议，请联系我司客服热线：400-6368688。
                  </p>
                  <p class="text2">2、应用名称：德讯证顾。</p>
                  <p class="text2">3、开发者名称：深圳德讯证券顾问有限公司。</p>
                  <p class="text2">
                    4、地址：广东省深圳市罗湖区笋岗街道田贝社区洪湖二街50号新南滨大厦3层-4层。
                  </p>
                  <p class="text_cent">
                  注：请您仔细阅读以上内容，在点击之前请您再次确认已知悉并完全理解本政策的全部内容，您点击“同意”按钮即视为您完全接受本隐私政策。
                  </p>
                </li> -->
              </ul>
            </div>
          </div>
         <div id="_dsf" v-if="showH.dsfqksm" class="hbox dsfqksmdsfqksm">
            <p class="textTitel">
              <span>第三方SDK情况说明</span>
            </p>
            <div class="textMain">
              <ul>
                <li>
                  <p class="text2">
                    为了确保您可以在不同设备类型上使用德讯证顾以及其接入的第三方服务，在向您提供服务过程中，基于实现在用户身份认证、手机设备安全、接收信息推送、登录第三方服务、通过第三方服务分享信息以及信息及交易安全的需要，德讯证顾接入了第三方SDK，其中部分第三方SDK可能会调用或获取您的相关信息。我们将这些第三方SDK的名称、使用目的、官网链接以及可能调用的权限分列明如下。
                  </p>
                </li>
                <li>
                  <p class="textTitle">一、登录分享类</p>
                  <p class="text2" style="font-weight: bold;">1. 微信开放平台(Android、iOS)</p>
                  <p class="text2">使用目的：帮助用户登录微信，并使用微信分享功能</p>
                  <p class="text2 ">官网链接：<a target="_blank" href="https://open.weixin.qq.com" class="decorations">https://open.weixin.qq.com</a></p>
                  <p class="text2">
                  隐私政策链接：<a target="_blank" href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy" class="decorations">https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy</a>
                  
                  </p>
                  <p class="text2">可能调用的权限：查看WLAN连接；读取手机状态和身份；读取外部存储卡；写入外部存储卡；读取MAC地址</p>
                  <p class="text2">收集个人信息类型：设备信息；位置信息；Wi-Fi地址；MAC地址</p>
                </li>
                <li>
                  <p class="text2" style="font-weight: bold;">2. QQ互联(Android、iOS)</p>
                  <p class="text2">使用目的：使用QQ账号的分享功能</p>
                  <p class="text2">官网链接：<a target="_blank" href="https://open.tencent.com/" class="decorations">https://open.tencent.com/</a></p>
                  <p class="text2">隐私政策链接：<a target="_blank" href="https://wiki.connect.qq.com/" class="decorations">https://wiki.connect.qq.com/</a>QQ互联SDK隐私保护声明</p>
                  <p class="text2">可能调用的权限：查看WLAN连接；读取手机状态和身份；读取外部存储卡；写入外部存储卡；读取MAC地址</p>
                  <p class="text2">收集个人信息类型：设备信息；Wi-Fi地址；MAC地址</p>
                </li>
                <li>
                  <p class="text2" style="font-weight: bold;">3. 友盟分享(Android)</p>
                  <p class="text2">使用目的：帮助用户更好的向各个平台分享内容</p>
                  <p class="text2">官网链接：<a target="_blank" href="https://www.umeng.com/" class="decorations">https://www.umeng.com/</a></p>
                  <p class="text2">隐私政策链接：<a target="_blank" href="https://www.umeng.com/page/policy?spm=a213m0.22488127.0.0.3cb275efBZHKoQ" class="decorations">https://www.umeng.com/page/policy?spm=a213m0.22488127.0.0.3cb275efBZHKoQ</a></p>
                  <p class="text2">可能调用的权限：访问网络；读取手机状态和身份；检索正在运行的应用；读取外部存储卡；写入外部存储卡收集</p>
                  <p class="text2">个人信息类型：设备信息；社交账号公开信息； 地理位置信息；已安装应用列表</p>
                </li>
                <li>
                  <p class="textTitle">二、推送类</p>
                  <p class="text2" style="font-weight: bold;">1. 极光推送(Android、iOS)</p>
                  <p class="text2">使用目的：向各渠道的用户进行消息推送</p>
                  <p class="text2">官网链接：<a target="_blank" href="https://www.jiguang.cn/" class="decorations">https://www.jiguang.cn/</a></p>
                  <p class="text2">隐私政策链接：<a target="_blank" href="https://www.jiguang.cn/license/privacy" class="decorations">https://www.jiguang.cn/license/privacy</a></p>
                  <p class="text2">可能调用的权限：查看WLAN连接；读取外置存储卡；开机启动；读取手机状态和身份；写入外部存储卡；检索正在运行的应用</p>
                  <p class="text2">收集个人信息类型：设备信息；Wi-Fi地址；运营商信息；已安装应用列表</p>
                </li>
                <li>
                  <p class="text2" style="font-weight: bold;">2. 华为推送(Android)</p>
                  <p class="text2">使用目的：向使用华为设备的用户进行消息推送</p>
                  <p class="text2">官网链接：<a target="_blank" href="https://developer.huawei.com/consumer/cn/codelab/HMSPushKit/index.html#0" class="decorations">https://developer.huawei.com/consumer/cn/codelab/HMSPushKit/index.html#0</a></p>
                  <p class="text2">隐私政策链接：<a target="_blank" href="https://consumer.huawei.com/cn/privacy/privacy-policy/" class="decorations">https://consumer.huawei.com/cn/privacy/privacy-policy/</a></p>
                  <p class="text2">可能调用的权限：读取手机状态和身份</p>
                  <p class="text2">收集个人信息类型：设备信息；运营商信息</p>
                </li>
                <li>
                  <p class="text2" style="font-weight: bold;">3. 小米推送(Android)</p>
                  <p class="text2">使用目的：向使用小米设备的用户进行消息推送</p>
                  <p class="text2">官网链接：<a target="_blank" href="https://dev.mi.com/console/appservice/push.html" class="decorations">https://dev.mi.com/console/appservice/push.html</a></p>
                  <p class="text2">隐私政策链接：<a target="_blank" href="https://dev.mi.com/console/doc/detail?pId=1822" class="decorations">https://dev.mi.com/console/doc/detail?pId=1822</a></p>
                  <p class="text2">可能调用的权限：查看WLAN连接；读取外置存储卡；开机启动；读取手机状态和身份；写入外部存储卡；检索正在运行的应用</p>
                  <p class="text2">收集个人信息类型：设备信息；运营商信息；已安装应用列表</p>
                </li>
                <li>
                  <p class="text2" style="font-weight: bold;">4. vivo推送(Android)</p>
                  <p class="text2">使用目的：向使用Vivo设备的用户进行消息推送</p>
                  <p class="text2">官网链接：<a target="_blank" href="https://dev.vivo.com.cn/home" class="decorations">https://dev.vivo.com.cn/home</a></p>
                  <p class="text2">隐私政策链接：<a target="_blank" href="https://www.vivo.com.cn/about-vivo/privacy-policy" class="decorations">https://www.vivo.com.cn/about-vivo/privacy-policy</a></p>
                  <p class="text2">可能调用的权限：读取外置存储卡；写入外部存储卡；检索正在运行的应用</p>
                  <p class="text2">收集个人信息类型：设备信息；运营商信息；已安装应用列表</p>
                </li>
                <li>
                  <p class="text2" style="font-weight: bold;">5. OPPO推送(Android)</p>
                  <p class="text2">使用目的：向使用OPPO设备的用户进行消息推送</p>
                  <p class="text2">官网链接：<a target="_blank" href="https://push.oppo.com/" class="decorations">https://push.oppo.com/</a></p>
                  <p class="text2">隐私政策链接：<a target="_blank" href="https://www.oppo.com/cn/service/help/640?id=640&name=服务政策&hdscreen=1" class="decorations">https://www.oppo.com/cn/service/help/640?id=640&name=服务政策&hdscreen=1</a></p>
                  <p class="text2">可能调用的权限：读取手机状态和身份</p>
                  <p class="text2">收集个人信息类型：设备信息；运营商信息</p>
                </li>
                <li>
                  <p class="text2" style="font-weight: bold;">6. 魅族推送(Android)</p>
                  <p class="text2">使用目的：向使用魅族设备的用户进行消息推送</p>
                  <p class="text2">官网链接：<a target="_blank" href="https://open.flyme.cn" class="decorations">https://open.flyme.cn</a></p>
                  <p class="text2">隐私政策链接：<a target="_blank" href="https://www.meizu.com/legal.html" class="decorations">https://www.meizu.com/legal.html</a></p>
                  <p class="text2">可能调用的权限：查看WLAN连接；读取外置存储卡；读取手机状态和身份；写入外部存储卡</p>
                  <p class="text2">收集个人信息类型：设备信息；Wi-Fi地址；运营商信息</p>
                </li>
                <li>
                  <p class="textTitle">三、支付类</p>
                  <p class="text2" style="font-weight: bold;">1. 微信支付(Android)</p>
                  <p class="text2">使用目的：帮助用户使用微信支付服务</p>
                  <p class="text2">官网链接：<a target="_blank" href="https://open.weixin.qq.com/" class="decorations">https://open.weixin.qq.com/</a></p>
                  <p class="text2">隐私政策链接：<a target="_blank" href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy" class="decorations">https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy</a></p>
                  <p class="text2">可能调用的权限：查看WLAN连接；读取手机状态和身份；检索正在运行的应用；读取MAC地址</p>
                  <p class="text2">收集个人信息类型：设备信息；Wi-Fi地址；MAC地址；已安装应用列表</p>
                </li>
                <li>
                  <p class="text2" style="font-weight: bold;">2. 支付宝支付(Android)</p>
                  <p class="text2">使用目的：帮助用户使用支付宝支付服务</p>
                  <p class="text2">官网链接：<a target="_blank" href="https://open.alipay.com/platform/home.htm" class="decorations">https://open.alipay.com/platform/home.htm</a></p>
                  <p class="text2">隐私政策链接：<a target="_blank" href="https://render.alipay.com/p/c/k2cx0tg8" class="decorations">https://render.alipay.com/p/c/k2cx0tg8</a></p>
                  <p class="text2">可能调用的权限：查看WLAN连接；读取手机状态和身份；检索正在运行的应用；读取MAC地址</p>
                  <p class="text2">收集个人信息类型：设备信息；Wi-Fi地址；MAC地址；已安装应用列表</p>
                </li>
                <li>
                  <p class="textTitle">四、其他类</p>
                  <p class="text2" style="font-weight: bold;">1. 广点通(Android)</p>
                  <p class="text2">使用目的：为用户提供更为准确的广告投放</p>
                  <p class="text2">官网链接：<a target="_blank" href="https://e.qq.com/ads/" class="decorations">https://e.qq.com/ads/</a></p>
                  <p class="text2">隐私政策链接：<a target="_blank" href="https://e.qq.com/optout.html" class="decorations">https://e.qq.com/optout.html</a></p>
                  <p class="text2">可能调用的权限：访问网络；获取广告标识符</p>
                  <p class="text2">收集个人信息类型：地理位置信息；设备信息；Wi-Fi地址；MAC地址</p>
                </li>
                <li>
                  <p class="text2" style="font-weight: bold;">2. 百度移动统计(Android、iOS)</p>
                  <p class="text2">使用目的：了解用户的使用情况，进行数据分析，以改善产品服务</p>
                  <p class="text2">官网链接：<a target="_blank" href="https://mtj.baidu.com/web/welcome/login/" class="decorations">https://mtj.baidu.com/web/welcome/login/</a></p>
                  <p class="text2">隐私政策链接：<a target="_blank" href="https://tongji.baidu.com/web/help/article?id=330&type=0&castk=LTE=l" class="decorations">https://tongji.baidu.com/web/help/article?id=330&type=0&castk=LTE=l</a></p></p>
                  <p class="text2">可能调用的权限：读取/写入外部存储卡；获取位置；获取运行的任务列表；</p>
                  <p class="text2">收集个人信息类型：设备信息；Wi-Fi地址；MAC地址；已安装应用列表；蓝牙状态</p>
                </li>
                <li>
                  <p class="text2" style="font-weight: bold;">3. Bugly(Android、iOS)</p>
                  <p class="text2">使用目的：应用异常上报，帮助开发者快速发现并解决异常</p>
                  <p class="text2">官网链接：<a target="_blank" href="https://bugly.qq.com/v2/" class="decorations">https://bugly.qq.com/v2/</a></p>
                  <p class="text2">隐私政策链接：<a target="_blank" href="https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf" class="decorations">https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf</a></p>
                  <p class="text2">可能调用的权限：访问网络；读取手机状态；查看WLAN连接；日志读取权限</p>
                  <p class="text2">收集个人信息类型：设备信息；Wi-Fi地址；MAC地址</p>
                </li>
                <li>
                  <p class="text2" style="font-weight: bold;">4. 对象存储OSS(Android、iOS)</p>
                  <p class="text2">使用目的：经用户选择文件并同意后，帮助用户上传媒体文件至阿里云 </p>
                  <p class="text2">官网链接：<a target="_blank" href="https://cn.aliyun.com/product/oss" class="decorations">https://cn.aliyun.com/product/oss</a></p>
                  <p class="text2">隐私政策链接：<a target="_blank" href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.7933691.J_9220772140.83.48044c59v3AqD1" class="decorations">http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.7933691.J_9220772140.83.48044c59v3AqD1</a></p>
                  <p class="text2">可能调用的权限：访问网络；读取外置存储卡；写入外部存储卡</p>
                  <p class="text2">收集个人信息类型：无</p>
                </li>
              </ul>
            </div>
         </div>
        </section>
      </div>
    </div>
    <Bottoms></Bottoms>
  </div>
</template>

<script>
import topNav from "../sub/topNav";
import Bottoms from "../sub/Bottoms";
export default {
  name: "B10_xgsm",
  components: { topNav, Bottoms },
  data() {
    return {
      imgsrc: require("../../common/images/lawColumn/backicon.png"),
      showH: {
        fxjss: true,
        mzsm: false,
        gssm: false,
        dcjys: false,
        dsfqksm: false, //第三方SDK情况说明。
      },
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.initfun();
    var str = this.$route.query.str;
    for (var x in this.showH) {
      this.showH[x] = false;
    }
    this.showH[str] = true;
    //console.log(links);
  },
  methods: {
    initfun: function () {},
    backfun: function () {
      this.$router.push({ path: "/about?index=" + 11 });
    },
    mosein: function () {
      this.imgsrc = require("../../common/images/lawColumn/backiconr.png");
    },
    mouseout: function () {
      this.imgsrc = require("../../common/images/lawColumn/backicon.png");
    },
    jump: function () {
      //跳转第三方SDK情况说明。
      console.log("+");
      console.log("=");
      window.scrollTo(0, 0);
      this.showH.dcjys = false;
      this.showH.dsfqksm = true;
      //
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  text-align: left;
}
.index {
  background: rgba(244, 244, 244, 1);
}
.lawcDetail {
  width: 1100px;
  overflow: hidden;
  opacity: 1;
  margin: 0 auto;
  min-height: 536px;
  background: rgba(255, 255, 255, 1);
}
.backconout {
  width: 100%;
  overflow: hidden;
}
.backcon {
  display: inline-block;
  float: left;
  width: auto;
  height: 22px;
  overflow: hidden;
  line-height: 22px;
  margin: 0 24px;
  box-sizing: border-box;
  margin-top: 24px;
  margin-bottom: 26px;
  cursor: pointer;
}
.backcon:hover .backconSpan {
  color: #e7413b;
}

.backcon span {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #666666;
  opacity: 1;
  padding-left: 12px;
}
.backcon img {
  padding: 2px 0;
}
.backcon span,
.backcon img {
  display: inline-block;
  float: left;
}
.inline-html {
  width: 676px;
  overflow: hidden;
  margin: 0 auto;
  padding-bottom: 60px;
}

/*  */

.text {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
  height: auto;
}
.text3_ul {
}
.text .hbox {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}
.textTitel {
  width: 100%;
  height: 42px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 42px;
  color: #333333;
  opacity: 1;
  text-align: center;
}
.textMain {
  margin-top: 20px;
}
.textMain {
}
.textMain .bold {
  width: 660px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 30px;
  color: #333333;
  opacity: 1;
}
.textMain .bold:last-child {
  margin-top: 10px;
}
.textMain .bold:first-child {
  margin-bottom: 10px;
}
.textMain .textRed {
  color: #e7413b;
}

.textMain .lip {
  width: 660px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #514444;
  opacity: 1;
}
.textMain .tred {
  color: #f6625c;
}
.mzsm {
  height: 784px;
}
.gssm {
  height: 784px;
}
.gssm li {
  margin-bottom: 10px;
}
.gssm .textMain p {
  width: 660px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #505050;
  opacity: 1;
}
.gssm .lititle {
  color: #f6625c !important;
  line-height: 14px !important;
  margin-bottom: 6px;
}

.textMain .textTitle {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 35px;
  color: #333333;
  opacity: 1;
}
.textMain .mintitle {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #505050;
  opacity: 1;
}
.textMain .text1 {
  text-indent: 2em;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #505050;
  opacity: 1;
}
.textMain .text2 {
  width: 660px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #505050;
  opacity: 1;
}
.textMain .text_cent {
  width: 660px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 27px;
  color: #333333;
  opacity: 1;
}
.textMain .text_title {
  text-indent: 2em;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 35px;
  color: #333333;
}
.textMain .text2_block {
  display: block;
  margin-right: 6px;
}
.textMain .text2_padding {
  display: flex;
  padding-left: 16px;
}
.active {
  color: #2929db;
  text-decoration: underline;
  cursor: pointer;
}
.decorations {
  text-decoration: underline;
  color: #180d28;
}
.shsj{
    text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutS/C01_dcjys.vue